import { Tooltip } from 'antd';
import { Link } from 'react-router';

import type { ReactNode } from 'react';
import type React from 'react';

const isExternalLink = (url: string) =>
  /^(mailto:|tel:|https?:\/\/)/i.test(url);

export const wrapWithTooltip = (
  node: React.ReactNode,
  tooltipLabel?: string,
) => {
  if (!tooltipLabel || !node) {
    return node;
  }

  return <Tooltip title={tooltipLabel}>{node}</Tooltip>;
};

export function wrapLabelWithLink(
  resolvedLabel: ReactNode,
  link: string | undefined,
): ReactNode {
  if (!link || resolvedLabel == null) {
    return resolvedLabel;
  }

  return isExternalLink(link) ? (
    <Link to={link} target="_blank" rel="noopener noreferrer">
      {resolvedLabel}
    </Link>
  ) : (
    <Link to={link}>{resolvedLabel}</Link>
  );
}
